function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import SortSelect from '@profile/src/Components/SortSelect_V2';
import SearchResult from './SearchResult';
import { useTypedSelector } from '@profile/src/redux/utils';
import HeaderTab from './Components/HeaderTab';
import useParamsRoute from '@profile/src/hooks/useRouteParams';
import { TestableProvider, useTestId } from '@wolffun/testable-id';
import { sortOptions } from '@profile/src/Profile_V2/Components/Inventory/CosmeticTab/config';

const HeroTab = ({
  className
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const totalItems = useTypedSelector(state => state.cosmeticInventory.totalItems);
  const ref = React.useRef(null);
  const {
    types = 'all'
  } = useParamsRoute();
  const {
    sort
  } = useParamsRoute();

  const onSortChanged = sortBy => {
    var _ref$current;

    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.onFetch({
      page: 1,
      types,
      sort: sortBy
    });
  };

  const onTabChange = filterType => {
    var _ref$current2;

    (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.onFetch({
      page: 1,
      types: filterType,
      sort
    });
  };

  return /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "cosmetic"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderTab, {
    status: types,
    onChange: onTabChange
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(SortSelect, _extends({}, generateTestIdProps('cosmetic', 'dropdown-list'), {
    value: sort,
    className: styles.sort,
    placeholder: "Filter by...",
    options: sortOptions,
    onSelect: onSortChanged
  }))), /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('cosmetic', 'total'), {
    className: styles.label
  }), "Items: ", totalItems, ' '), /*#__PURE__*/React.createElement(SearchResult, {
    ref: ref
  })));
};

export default HeroTab;